import { render, staticRenderFns } from "./Saques.vue?vue&type=template&id=dafb606e&scoped=true&"
import script from "./Saques.vue?vue&type=script&lang=js&"
export * from "./Saques.vue?vue&type=script&lang=js&"
import style0 from "./Saques.vue?vue&type=style&index=0&id=dafb606e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafb606e",
  null
  
)

export default component.exports